module.exports = __webpack_public_path__ + "media/images/athletes/235-ffdeb79f573cab16a22b67041b17455c.png";